<template>
  <div
    v-if="mobileView"
    @mouseenter="renderDropdown = true"
    @touchstart="renderDropdown = true"
  >
    <div class="flex space-x-2 items-end overflow-y-scroll">
      <div class="group/contenteditable-container bg-base-100 rounded-md p-2 border border-base-300 w-full flex justify-between items-end">
        <div class="flex items-center space-x-2">
          <span
            class="w-3 h-3 flex-shrink-0 rounded-full"
            :class="colors[submitters.indexOf(selectedSubmitter)]"
          />
          <Contenteditable
            v-model="selectedSubmitter.name"
            class="cursor-text"
            :icon-inline="true"
            :editable="editable"
            :select-on-edit-click="true"
            :icon-width="18"
            @update:model-value="$emit('name-change', selectedSubmitter)"
          />
        </div>
      </div>
      <div class="dropdown dropdown-top dropdown-end">
        <label
          tabindex="0"
          class="bg-base-100 cursor-pointer rounded-md p-2 border border-base-300 w-full flex justify-center"
        >
          <IconChevronUp
            width="24"
            height="24"
          />
        </label>
        <ul
          v-if="editable && renderDropdown"
          tabindex="0"
          class="rounded-md min-w-max mb-2"
          :class="menuClasses"
          :style="menuStyle"
          @click="closeDropdown"
        >
          <li
            v-for="(submitter, index) in submitters"
            :key="submitter.uuid"
          >
            <a
              href="#"
              class="flex px-2 group justify-between items-center"
              :class="{ 'active': submitter === selectedSubmitter }"
              @click.prevent="selectSubmitter(submitter)"
            >
              <span class="py-1 flex items-center">
                <span
                  class="rounded-full w-3 h-3 ml-1 mr-3"
                  :class="colors[index]"
                />
                <span>
                  {{ submitter.name }}
                </span>
              </span>
              <button
                v-if="submitters.length > 1 && editable"
                class="px-2"
                @click.prevent.stop="remove(submitter)"
              >
                <IconTrashX :width="18" />
              </button>
            </a>
          </li>
          <li v-if="submitters.length < names.length && editable">
            <a
              href="#"
              class="flex px-2"
              @click.prevent="addSubmitter"
            >
              <IconUserPlus
                :width="20"
                :stroke-width="1.6"
              />
              <span class="py-1">
                {{ t('add') }} {{ names[submitters.length] }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div
    v-else
    class="dropdown"
    @mouseenter="renderDropdown = true"
    @touchstart="renderDropdown = true"
  >
    <label
      v-if="compact"
      tabindex="0"
      :title="selectedSubmitter?.name"
      class="cursor-pointer text-base-100 flex h-full items-center justify-center"
    >
      <button
        class="mx-1 w-3 h-3 rounded-full"
        :class="colors[submitters.indexOf(selectedSubmitter)]"
      />
    </label>
    <label
      v-else
      ref="label"
      tabindex="0"
      class="group cursor-pointer group/contenteditable-container rounded-md p-2 border border-base-300 hover:border-content w-full flex justify-between"
    >
      <div class="flex items-center space-x-2">
        <span
          class="w-3 h-3 rounded-full"
          :class="colors[submitters.indexOf(selectedSubmitter)]"
        />
        <Contenteditable
          v-model="selectedSubmitter.name"
          class="cursor-text"
          :icon-inline="true"
          :editable="editable"
          :select-on-edit-click="true"
          :icon-width="18"
          @update:model-value="$emit('name-change', selectedSubmitter)"
        />
      </div>
      <div class="flex items-center">
        <template v-if="editable">
          <span
            class="cursor-pointer flex items-center justify-center transition-all duration-75 hover:bg-base-200 w-6 h-6 rounded mr-1"
            title="Pilih Kontak"
            @click.stop="handleAddressBookClick"
          >
            <IconAddressBook
              width="18"
              height="18"
            />
          </span>
          <span
            class="cursor-pointer flex items-center justify-center transition-all duration-75 hover:bg-base-200 w-6 h-6 rounded"
            @click.stop="handlePlusClick"
          >
            <IconPlus
              width="18"
              height="18"
            />
          </span>
        </template>
        <span
          v-else
          class="flex items-center transition-all duration-75 group-hover:border border-base-content/20 border-dashed w-6 h-6 flex justify-center items-center rounded"
        >
          <IconChevronDown
            width="18"
            height="18"
          />
        </span>
      </div>
    </label>

    <!-- Existing Modal with Form Add Contact -->
    <div
      id="contactModal"
      :class="`modal fade ${isModalOpen && 'modal-open'} !animate-none overflow-y-auto flex items-center justify-center`"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-50"
        @click.self="isModalOpen = false"
      >
        <div class="modal-box pt-4 pb-6 px-6 max-h-none w-full max-w-xl mx-auto mt-[10vh]">
          <!-- Modal Content Form Contact -->
          <div class="modal-content-form">
            <div class="flex justify-between items-center border-b pb-2 mb-2 font-medium">
              <span>Select or Add Contact</span>
              <a
                href="#"
                class="text-xl"
                @click.prevent="isModalOpen = false"
              >&times;</a>
            </div>

            <form
              class="mb-6"
              @submit.prevent="onSubmitNewContact"
            >
              <div class="mb-4">
                <label class="label">
                  <span class="label-text">Name</span>
                </label>
                <input
                  v-model="newContact.name"
                  type="text"
                  class="input input-sm input-bordered w-full"
                  required
                >
                <div
                  v-if="inputContactErrors.name"
                  class="text-red-500 text-sm mt-1"
                >
                  {{ inputContactErrors.name }}
                </div>
              </div>

              <div class="mb-4">
                <label class="label">
                  <span class="label-text">Email</span>
                </label>
                <input
                  v-model="newContact.email"
                  type="email"
                  class="input input-sm input-bordered w-full"
                  required
                >
                <div
                  v-if="inputContactErrors.email"
                  class="text-red-500 text-sm mt-1"
                >
                  {{ inputContactErrors.email }}
                </div>
              </div>

              <div class="flex justify-end space-x-2">
                <button
                  type="button"
                  class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-300"
                  @click="isModalOpen = false"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                >
                  Save
                </button>
              </div>
            </form>
          </div>

          <!-- Modal Content Contact List -->
          <div class="modal-content-contact-list">
            <div class="flex items-center justify-between mb-2 border-b pb-1">
              <h2 class="text-lg font-semibold text-gray-800">
                Edit Existing Contacts
              </h2>
              <button
                class="btn btn-sm ml-2
                      bg-purple-800 text-white
                      hover:bg-purple-900
                      rounded-md
                      px-3 py-1
                      transition-colors duration-300
                      flex items-center gap-1
                      normal-case group"
                @click="refreshLocalContacts"
              >
                <IconRefresh
                  size="18"
                  class="opacity-70 transition-transform duration-300 group-hover:rotate-180"
                />
                Refresh
              </button>
            </div>
            <input
              v-model="searchKey"
              type="text"
              class="input input-sm input-bordered w-full mb-2"
              placeholder="Search"
            >

            <div class="relative max-h-80 overflow-x-auto rounded">
              <table class="min-w-[600px] text-sm text-left rtl:text-right">
                <thead class="text-xs text-gray-700 uppercase bg-base-200">
                  <tr>
                    <th class="px-6 py-3">
                      Name
                    </th>
                    <th class="px-6 py-3">
                      Email
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(contact, index) in allContacts"
                    :key="`contact-${index}`"
                    class="border-b hover:cursor-pointer hover:bg-base-300"
                    @click="selectContact(contact)"
                  >
                    <td class="px-6 py-4">
                      {{ contact.name }}
                      <span v-if="contact.source === 'contact'" class="ml-2 text-xs italic text-gray-500" title="This contact is managed by your organization and cannot be edited.">Managed</span>
                      <template v-else-if="!contact.source || (contact.source !== 'contact_book' && contact.source !== 'contact')">
                        <span class="ml-2 text-xs italic text-amber-400 inline-flex items-center gap-0.5" title="This contact is temporary and will be removed after refresh. It is not saved to your contact list."><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="inline-block"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>Not saved</span>
                        <button type="button" class="ml-1 p-0.5 text-red-400 hover:bg-red-50 rounded transition-colors" title="Remove Contact?" @click.stop="onDeleteTempContact(index)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>
                        </button>
                      </template>
                    </td>
                    <td class="px-6 py-4">
                      {{ contact.email }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Temporary Contact Confirmation Modal -->
    <div
      id="deleteTempContactModal"
      :class="`modal fade ${isDeleteTempModalOpen && 'modal-open'} !animate-none overflow-y-auto flex items-center justify-center`"
      style="z-index: 1000010"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-50"
        @click.self="isDeleteTempModalOpen = false"
      >
        <div class="modal-box pt-4 pb-6 px-6 w-full max-w-sm mx-auto mt-[20vh] bg-white rounded-xl shadow-xl relative z-50">
          <div class="text-center">
            <div
              class="mx-auto flex items-center justify-center w-12 h-12 rounded-full bg-red-100 mb-4"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-red-500"
              >
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-800 mb-2">
              Remove contact?
            </h3>
            <p class="font-medium text-gray-800 mb-2">
              "{{ tempContactToDelete?.name || tempContactToDelete?.email }}"
            </p>
            <p class="text-sm text-gray-500 mb-6">
              This contact is temporary and will be removed after refresh. If needed again, it must be re-entered manually.
            </p>
            <div class="flex justify-center gap-3">
              <button
                type="button"
                class="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200 transition-colors"
                @click="isDeleteTempModalOpen = false"
              >
                Cancel
              </button>
              <button
                type="button"
                class="px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
                @click="onConfirmDeleteTemp"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ul
      v-if="(editable || !compact) && renderDropdown"
      tabindex="0"
      :class="menuClasses"
      :style="menuStyle"
      @click="closeDropdown"
    >
      <li
        v-for="(submitter, index) in submitters"
        :key="submitter.uuid"
      >
        <a
          href="#"
          class="flex px-2 group justify-between items-center"
          :class="{ 'active': submitter === selectedSubmitter, 'py-0.5': submitters.length > 8 }"
          @click.prevent="selectSubmitter(submitter)"
        >
          <span class="py-1 flex items-center">
            <span
              class="rounded-full w-3 h-3 ml-1 mr-3"
              :class="colors[index]"
            />
            <span>
              {{ submitter.name }}
            </span>
          </span>
          <div
            v-if="!compact && submitters.length > 1 && editable"
            class="flex"
          >
            <div class="flex-col pr-1 hidden group-hover:flex -mt-1 h-0">
              <button
                :title="t('up')"
                class="relative w-2"
                style="font-size: 10px; margin-bottom: -4px"
                @click.prevent.stop="[move(submitter, -1), $refs.label.focus()] "
              >
                ▲
              </button>
              <button
                :title="t('down')"
                class="relative w-2"
                style="font-size: 10px; margin-top: -4px"
                @click.prevent.stop="[move(submitter, 1), $refs.label.focus()] "
              >
                ▼
              </button>
            </div>
            <button
              v-if="!compact && submitters.length > 1 && editable"
              class="hidden group-hover:block px-2"
              @click.prevent.stop="remove(submitter)"
            >
              <IconTrashX :width="18" />
            </button>
          </div>
        </a>
      </li>
      <li v-if="submitters.length < names.length && editable && allowAddNew">
        <a
          href="#"
          class="flex px-2"
          @click.prevent="addSubmitter"
        >
          <IconUserPlus
            :width="20"
            :stroke-width="1.6"
          />
          <span class="py-1">
            {{ t('add') }} {{ names[submitters.length] }}
          </span>
        </a>
      </li>
    </ul>
  </div>

  <!-- Toast Notification -->
  <Teleport to="body">
    <transition name="toast-fade">
      <div
        v-if="toastMessage"
        class="fixed top-6 right-6 bg-green-500 text-white px-5 py-3 rounded-lg shadow-lg text-sm font-medium flex items-center gap-2"
        style="z-index: 1000010"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M20 6L9 17l-5-5" />
        </svg>
        {{ toastMessage }}
      </div>
    </transition>
  </Teleport>
</template>

<script>
import { IconUserPlus, IconTrashX, IconPlus, IconChevronUp, IconChevronDown, IconAddressBook, IconRefresh } from '@tabler/icons-vue'
import Contenteditable from './contenteditable'
import { debounceFilter, watchWithFilter } from '@vueuse/core'
import { v4 } from 'uuid'

export default {
  name: 'FieldSubmitter',
  components: {
    IconUserPlus,
    IconChevronDown,
    Contenteditable,
    IconPlus,
    IconTrashX,
    IconChevronUp,
    IconAddressBook,
    IconRefresh
  },
  inject: ['t', 'save'],
  props: {
    submitters: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    mobileView: {
      type: Boolean,
      required: false,
      default: false
    },
    allowAddNew: {
      type: Boolean,
      required: false,
      default: true
    },
    modelValue: {
      type: String,
      required: true
    },
    menuStyle: {
      type: Object,
      required: false,
      default: () => ({})
    },
    menuClasses: {
      type: String,
      required: false,
      default: 'dropdown-content menu p-2 shadow rounded-box w-full z-10'
    }
  },
  emits: ['update:model-value', 'remove', 'new-submitter', 'name-change'],
  data () {
    return {
      renderDropdown: false,
      isModalOpen: false,
      allContacts: [],
      searchKey: '',
      newContact: {
        name: '',
        email: ''
      },
      LOCAL_RECEPIENT_FORM_KEY: 'local-receipient-form',
      toastMessage: '',
      inputContactErrors: {
        name: '',
        email: ''
      },
      isDeleteTempModalOpen: false,
      tempContactToDeleteIndex: null,
      tempContactToDelete: null
    }
  },
  computed: {
    colors () {
      return [
        'bg-red-500',
        'bg-sky-500',
        'bg-emerald-500',
        'bg-yellow-300',
        'bg-purple-600',
        'bg-pink-500',
        'bg-cyan-500',
        'bg-orange-500',
        'bg-lime-500',
        'bg-indigo-500',
        'bg-red-500',
        'bg-sky-500',
        'bg-emerald-500',
        'bg-yellow-300',
        'bg-purple-600',
        'bg-pink-500',
        'bg-cyan-500',
        'bg-orange-500',
        'bg-lime-500',
        'bg-indigo-500',
        'bg-red-500',
        'bg-sky-500',
        'bg-emerald-500',
        'bg-yellow-300',
        'bg-purple-600',
        'bg-pink-500',
        'bg-cyan-500',
        'bg-orange-500',
        'bg-lime-500',
        'bg-indigo-500',
        'bg-red-500',
        'bg-sky-500',
        'bg-emerald-500',
        'bg-yellow-300',
        'bg-purple-600',
        'bg-pink-500',
        'bg-cyan-500',
        'bg-orange-500',
        'bg-lime-500',
        'bg-indigo-500',
        'bg-red-500',
        'bg-sky-500',
        'bg-emerald-500',
        'bg-yellow-300',
        'bg-purple-600',
        'bg-pink-500',
        'bg-cyan-500',
        'bg-orange-500',
        'bg-lime-500',
        'bg-indigo-500'
      ]
    },
    names () {
      return [
        this.t('first_party'),
        this.t('second_party'),
        this.t('third_party'),
        this.t('fourth_party'),
        this.t('fifth_party'),
        this.t('sixth_party'),
        this.t('seventh_party'),
        this.t('eighth_party'),
        this.t('ninth_party'),
        this.t('tenth_party'),
        this.t('eleventh_party'),
        this.t('twelfth_party'),
        this.t('thirteenth_party'),
        this.t('fourteenth_party'),
        this.t('fifteenth_party'),
        this.t('sixteenth_party'),
        this.t('seventeenth_party'),
        this.t('eighteenth_party'),
        this.t('nineteenth_party'),
        this.t('twentieth_party'),
        this.t('twenty_first_party'),
        this.t('twenty_second_party'),
        this.t('twenty_third_party'),
        this.t('twenty_fourth_party'),
        this.t('twenty_fifth_party'),
        this.t('twenty_sixth_party'),
        this.t('twenty_seventh_party'),
        this.t('twenty_eighth_party'),
        this.t('twenty_ninth_party'),
        this.t('thirtieth_party'),
        this.t('thirty_first_party'),
        this.t('thirty_second_party'),
        this.t('thirty_third_party'),
        this.t('thirty_fourth_party'),
        this.t('thirty_fifth_party'),
        this.t('thirty_sixth_party'),
        this.t('thirty_seventh_party'),
        this.t('thirty_eighth_party'),
        this.t('thirty_ninth_party'),
        this.t('fortieth_party'),
        this.t('forty_first_party'),
        this.t('forty_second_party'),
        this.t('forty_third_party'),
        this.t('forty_fourth_party'),
        this.t('forty_fifth_party'),
        this.t('forty_sixth_party'),
        this.t('forty_seventh_party'),
        this.t('forty_eighth_party'),
        this.t('forty_ninth_party'),
        this.t('fiftieth_party')
      ]
    },
    selectedSubmitter () {
      return this.submitters.find((e) => e.uuid === this.modelValue)
    }
  },

  created () {
    // Add event listener for ESC key to close modal
    window.addEventListener('keydown', this.handleEsc)
  },

  beforeUnmount () {
    // Clean up event listener
    window.removeEventListener('keydown', this.handleEsc)
    if (this.toastTimeoutId) clearTimeout(this.toastTimeoutId)
  },

  mounted () {
    watchWithFilter(
      () => this.searchKey,
      () => {
        this.getAllContacts(this.searchKey)
      },
      { eventFilter: debounceFilter(500, { maxWait: 1000 }) }
    )
  },
  methods: {
    showToast (message) {
      if (this.toastTimeoutId) clearTimeout(this.toastTimeoutId)
      this.toastMessage = message
      this.toastTimeoutId = setTimeout(() => {
        this.toastMessage = ''
      }, 3000)
    },
    selectSubmitter (submitter) {
      this.$emit('update:model-value', submitter.uuid)
    },
    remove (submitter) {
      if (window.confirm(this.t('are_you_sure'))) {
        this.$emit('remove', submitter)
      }
    },
    move (submitter, direction) {
      const currentIndex = this.submitters.indexOf(submitter)

      this.submitters.splice(currentIndex, 1)

      if (currentIndex + direction > this.submitters.length) {
        this.submitters.unshift(submitter)
      } else if (currentIndex + direction < 0) {
        this.submitters.push(submitter)
      } else {
        this.submitters.splice(currentIndex + direction, 0, submitter)
      }

      this.selectSubmitter(submitter)

      this.save()
    },
    addSubmitter () {
      const newSubmitter = {
        name: this.names[this.submitters.length],
        email: '', // Initialize with empty email
        uuid: v4()
      }

      this.submitters.push(newSubmitter)

      this.$emit('update:model-value', newSubmitter.uuid)
      this.$emit('new-submitter', newSubmitter)
    },
    closeDropdown () {
      document.activeElement.blur()
    },
    handleAddressBookClick () {
      this.isModalOpen = true
      // Load contacts when opening the modal if none are loaded yet
      if (this.allContacts.length === 0) {
        this.getAllContacts(this.searchKey)
      }
    },

    getAllContacts: async function (text) {
      const q = text.split(/[;,]+/).pop().trim()
      const queryParams = new URLSearchParams({ q })

      const keyword = this.searchKey.trim().toLowerCase() || ''

      try {
        const resp = await fetch('/submitters_autocomplete?' + queryParams)
        const fetched = await resp.json()

        const filtered = keyword
          ? fetched.filter(c =>
            (c.email && c.email.toLowerCase().includes(keyword)) ||
          (c.name && c.name.toLowerCase().includes(keyword))
          )
          : fetched

        this.allContacts = filtered
      } catch (error) {
        console.error('Error fetching contacts:', error)
      }
    },

    selectContact (contact) {
      this.isModalOpen = false

      // Update the current submitter's name and email with the selected contact's information
      if (this.selectedSubmitter) {
        this.selectedSubmitter.name = contact.name
        this.selectedSubmitter.email = contact.email

        // Set the contact information in recepient contact storage
        localStorage.setItem(this.LOCAL_RECEPIENT_FORM_KEY, JSON.stringify(contact))

        // Emit the name change event to notify parent components
        this.$emit('name-change', this.selectedSubmitter)
      }
    },
    handlePlusClick () {
      // Use the existing addSubmitter method or create new functionality
      this.addSubmitter()
    },
    handleEsc (event) {
      if (event.key === 'Escape') {
        this.isModalOpen = false
      }
    },
    onSubmitNewContact () {
      // Reset previous errors
      this.inputContactErrors = {
        name: '',
        email: ''
      }

      // Basic validation
      let hasError = false
      if (!this.newContact.name) {
        this.inputContactErrors.name = 'Name is required'
        hasError = true
      }

      if (!this.newContact.email) {
        this.inputContactErrors.email = 'Email is required'
        hasError = true
      }

      if (hasError) return

      const nameLower = this.newContact.name.trim().toLowerCase()
      const emailLower = this.newContact.email.trim().toLowerCase()

      // Only check duplicates against DB-sourced contacts (contact_book and contact)
      const dbContacts = this.allContacts.filter(contact =>
        contact.source === 'contact_book' || contact.source === 'contact'
      )

      const isDuplicateName = dbContacts.some(contact =>
        contact.name?.toLowerCase() === nameLower
      )
      const isDuplicateEmail = dbContacts.some(contact =>
        contact.email?.toLowerCase() === emailLower
      )

      if (isDuplicateName) {
        this.inputContactErrors.name = 'Name already exists'
      }

      if (isDuplicateEmail) {
        this.inputContactErrors.email = 'Email already exists'
      }

      if (isDuplicateName || isDuplicateEmail) return

      // Remove any temporary (Not saved) contacts with the same email or name before saving
      this.allContacts = this.allContacts.filter(c =>
        c.source === 'contact_book' ||
        c.source === 'contact' ||
        (c.email?.toLowerCase() !== emailLower &&
         c.name?.toLowerCase() !== nameLower)
      )

      // Save to database via API
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      fetch('/api/contact_books', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          contact_book: { name: this.newContact.name.trim(), email: this.newContact.email.trim() }
        })
      }).then(resp => resp.json()).then(async data => {
        if (data.contact?.id) {
          await this.getAllContacts(this.searchKey)
          this.showToast('Contact added successfully.')
        }
      }).catch(err => console.error('Failed to save contact to DB:', err))

      // Set contact information to recepient contact storage
      localStorage.setItem(this.LOCAL_RECEPIENT_FORM_KEY, JSON.stringify(this.newContact))

      // Set contact
      this.selectContact(this.newContact)

      // Reset Modal
      this.isModalOpen = false

      // Reset form
      this.newContact = { name: '', email: '' }
    },
    onDeleteTempContact (index) {
      const contact = this.allContacts[index]
      if (!contact) return

      this.tempContactToDelete = contact
      this.tempContactToDeleteIndex = index
      this.isDeleteTempModalOpen = true
    },
    onConfirmDeleteTemp () {
      if (this.tempContactToDeleteIndex === null) return

      this.allContacts.splice(this.tempContactToDeleteIndex, 1)
      this.showToast('Temporary contact removed.')

      this.isDeleteTempModalOpen = false
      this.tempContactToDelete = null
      this.tempContactToDeleteIndex = null
    },
    async refreshLocalContacts () {
      await this.getAllContacts(this.searchKey)
      this.showToast('Contacts refreshed from server.')
      console.log('Contacts refreshed from server.')
    }
  }
}
</script>

<style scoped>
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}
.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
